var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadgeGift = function SvgBadgeGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#05071A",
    clipPath: "url(#badgeGift_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.718 3.5a.146.146 0 0 0 .146.146h2.479a.51.51 0 0 0 .51-.51v-.584a.51.51 0 0 0-.51-.51H3.864a.146.146 0 0 0-.146.146zM1.02 3.646h2.115a.146.146 0 0 0 .146-.146V2.188a.146.146 0 0 0-.146-.146H.51a.51.51 0 0 0-.51.51v.584a.51.51 0 0 0 .51.51zM3.28 4.23a.146.146 0 0 0-.145-.146H.729a.146.146 0 0 0-.146.146v2.26a.51.51 0 0 0 .51.51h2.042a.146.146 0 0 0 .146-.146zM3.864 4.084a.146.146 0 0 0-.146.146v2.624A.146.146 0 0 0 3.864 7H5.76a.51.51 0 0 0 .51-.51V4.23a.146.146 0 0 0-.146-.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73 1.957a.29.29 0 0 0 .276.077c.345-.085 1.175-.308 1.429-.562A.863.863 0 1 0 4.214.253c-.22.22-.431.897-.561 1.43a.3.3 0 0 0 .078.274M4.628.666a.279.279 0 1 1 .395.394 2.6 2.6 0 0 1-.666.272q.089-.352.271-.666M3.345 1.68c-.13-.53-.34-1.206-.56-1.427a.863.863 0 1 0-1.22 1.22c.253.253 1.083.476 1.429.56a.29.29 0 0 0 .275-.076.3.3 0 0 0 .076-.276m-1.368-.62a.279.279 0 1 1 .395-.395q.181.315.271.667a2.6 2.6 0 0 1-.666-.272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "badgeGift_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h7v7H0z"
  })))));
};
export default SvgBadgeGift;